/** @jsxImportSource minimal-view */

export function AsciiSvg({
  lines,
  strokeWidth = 6.15,
  linejoin = "miter",
  linecap = "square",
  connect = false
}: {
  lines: string[][]
  strokeWidth?: number
  linejoin?: string
  linecap?: string
  connect?: boolean
}) {
  const allPoints = []
  for (const listOfStrings of lines) {
    const points: string[] = [];
    const listLength = listOfStrings.length;
    const striLength = listOfStrings[0].length;

    for (const list of listOfStrings) {
      if (list.length !== striLength) {
        throw new Error("Strings of different lengths passed");
      }
    }

    const xUnit = 100 / striLength;
    const yUnit = 100 / listLength;

    let lastRetrievedPoint = 0;
    let currentlySearchedForPoint = 0;

    while (currentlySearchedForPoint <= lastRetrievedPoint) {
      currentlySearchedForPoint++;
      for (let listIndex = 0; listIndex < listLength; listIndex++) {
        const currentString = listOfStrings[listIndex];
        const splitString = currentString.split('')
        for (let striIndex = 0; striIndex < striLength; striIndex++) {
          const currentChar = splitString[striIndex];
          if (currentChar === currentlySearchedForPoint.toString()) {
            const x = (striIndex + 1) * xUnit - xUnit / 2;
            const y = (listIndex + 1) * yUnit - yUnit / 2;
            points.push(`${x},${y}`);
            lastRetrievedPoint++;
          }
        }
      }
    }
    allPoints.push(points)
  }

  const El = connect
    ? (props: any) => <polygon {...props} />
    : (props: any) => <polyline {...props} />

  const svg = <svg
    width="100%"
    height="100%"
    viewBox='0 0 100 100'
  // preserveAspectRatio='xMidYMid slice'
  >
    {allPoints.map((points) =>
      <El
        fill='transparent'
        stroke-width={strokeWidth}
        stroke-linecap={linecap}
        stroke-linejoin={linejoin}
        points={points.map(point => ` ${point}`).join('')
        } />
    )}
  </svg>

  return svg
}
